import React, { useId, useState } from 'react';

// DJB-177/180: collapsible overview card for one configuration model. Cards
// start collapsed: the header keeps the name + actions plus a one-line
// summary; the body (the full entries table) stays mounted while collapsed
// and is hidden by CSS, matching the DashboardSection shell behaviour.
const ModelCard = ({ title, summary, actions, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const bodyId = useId();

  return (
    <article className={`config-mode-card ${isOpen ? 'is-open' : 'is-collapsed'}`}>
      <header className="config-mode-card-header">
        <h3 className="config-mode-card-title">
          <button
            type="button"
            className="config-mode-card-toggle"
            aria-expanded={isOpen}
            aria-controls={bodyId}
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <span className="config-card-chevron" aria-hidden="true" />
            {title}
          </button>
        </h3>
        {actions && <div className="config-mode-card-actions">{actions}</div>}
      </header>
      {!isOpen && summary && <p className="config-mode-card-summary">{summary}</p>}
      <div className="config-mode-card-body" id={bodyId}>
        {children}
      </div>
    </article>
  );
};

export default ModelCard;
